import {get} from "svelte/store";
import {cartItemsStore} from "../cart/cart-store.js";
import {favsStore} from "./app-store.js";

export const getFavoriteItems = (menu) => {

    const favs = (get(favsStore) || []).filter(Boolean);

    return menu.sections
        .filter(x => x.records?.length > 0)
        .map(x => x.records.filter(r => favs.includes(r.id)))
        .filter(x => x.length > 0)
        .reduce((a,b) => [...a, ...b], []);
};
